export const ScheduleType = {
  ASAP: 'ASAP',
  PREBOOKING: 'PREBOOKING',
};
